export default {
    "Casa Acacia2": "https://umbra3d.studio/recorridos/oikos/savanna-santa-clara/",
    "Casa Acacia": "https://toures.lacuartapared.com/acacia/",
}